// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ARSP","select":"styles_select__3HtpK"};